import { Pipe, PipeTransform } from '@angular/core';
import {DevicePropertyVisibilityConfiguration} from '../../project/models/project-configuration';
import {Device} from '../models/monitored-train';

@Pipe({
  name: 'showDeviceProperty'
})
export class ShowDevicePropertyPipe implements PipeTransform {

  transform(property: string, device: Device, devicePropertyVisibilityConfigurations: DevicePropertyVisibilityConfiguration[]): boolean {
    const currentDeviceConfiguration = devicePropertyVisibilityConfigurations && devicePropertyVisibilityConfigurations.find(config => {
      return config.type === device.type;
    });
    const hiddenProperties = currentDeviceConfiguration ? currentDeviceConfiguration.hiddenProperties : [];
    return !(hiddenProperties.find(hiddenProperty => hiddenProperty === property));
  }

}
